function handleNetworkError() {
    const error = { code: 'NetworkError', message: 'There is a network issue and your request could not be processed.' };
    throw error;
}
function isJSONResponse(response) {
    if (!response) {
        return false;
    }
    return response.headers.has('Content-Type') && response.headers.get('Content-Type').indexOf('application/json') > -1;
}
function handleResponseStatus(response) {
    const isJSON = isJSONResponse(response);
    if (response.ok) {
        return isJSON ? response.json() : response.text();
    }
    if (isJSON) {
        return response.json().then((apiError) => {
            throw apiError;
        });
    }
    const error = { code: 'ServerError', message: 'We couldn\'t process your request. Please try again or call us at 1.800.764.7419.', response: response };
    throw error;
}
export function cclFetch(input, init) {
    const credentials = 'include';
    const initWithCredentials = Object.assign({ credentials: credentials }, init);
    return fetch(input, initWithCredentials)
        .catch(handleNetworkError)
        .then((response) => handleResponseStatus(response));
}
export function cclFetchRaw(input, init) {
    const credentials = 'include';
    const initWithCredentials = Object.assign({ credentials: credentials }, init);
    return fetch(input, initWithCredentials)
        .catch(handleNetworkError)
        .then((response) => handleResponseStatus(response).then(data => ({ data, response })));
}
//# sourceMappingURL=ccl-fetch.js.map